import allPass from 'ramda/src/allPass'
import has from 'ramda/src/has'

// eslint-disable-next-line import/prefer-default-export
export const hasBrandSettings = allPass([has('brandName'), has('brandWebsite'), has('brandLogo')])
